import api from './api';

function extractArray(data, keys = []) {
  if (Array.isArray(data)) return data;
  for (const key of keys) {
    if (Array.isArray(data?.[key])) return data[key];
  }
  return [];
}

export async function fetchCategories() {
  const { data } = await api.get('/inventario_productos/filtros');
  return extractArray(data, ['categorias']);
}

export async function fetchProductCache({ maxPages = 4 } = {}) {
  let afterId = 0;
  const rows = [];
  let pages = 0;

  do {
    const { data } = await api.get('/inventario_productos/pos-cache', {
      params: { limit: 5000, after_id: afterId },
      timeout: 30000,
    });

    const productos = extractArray(data, ['productos']);
    rows.push(...productos.filter((row) => !row?.deleted));
    pages += 1;

    if (!data?.has_more || !data?.next_cursor || pages >= maxPages) break;
    afterId = Number(data.next_cursor) || 0;
  } while (afterId > 0);

  return rows;
}

export async function fetchCajaEstado() {
  const { data } = await api.get('/pos_cajas/estado');
  if (!data?.abierta) return { abierta: false, caja: null };
  const caja = data?.caja && typeof data.caja === 'object' ? data.caja : data;
  if (!caja?.id) return { abierta: true, caja };
  try {
    const detail = await api.get(`/pos_cajas/${caja.id}/estado`);
    const detailCaja = detail?.data?.caja && typeof detail.data.caja === 'object' ? detail.data.caja : detail?.data;
    return { abierta: true, caja: { ...caja, ...(detailCaja || {}) } };
  } catch (_) {
    return { abierta: true, caja };
  }
}

export async function abrirCaja(montoInicial) {
  const { data } = await api.post('/pos_cajas/abrir', {
    monto_inicial: Math.max(0, Math.round(Number(montoInicial || 0))),
  });
  return data?.caja || data;
}

export async function fetchMetodosPago() {
  const { data } = await api.get('/tesoreria/metodos-contabilidad', {
    params: { visible_pos: true, activo: true },
  });
  return extractArray(data, ['rows', 'metodos', 'items', 'data']);
}

export async function buscarClientes(search = '') {
  const { data } = await api.get('/ventas_clientes', {
    params: { search: search || undefined, limit: 25 },
  });
  return extractArray(data, ['clientes', 'rows', 'items', 'data']);
}

export async function fetchCliente(id) {
  const { data } = await api.get(`/ventas_clientes/${id}`);
  return data?.cliente || data?.data?.cliente || data;
}
